// import {http} from '../../axios'
import Vue from 'vue'

const mutationsSubscribeNames = [
  'setResultParams',
]

function getInitState() {
  return {
    muted: false,
    pendingLoad: false,
    resultParams: {}
  }
}


export default {
  namespaced: true,
  state: {
    ...getInitState(),
    mutationsSubscribeNames,
    paramsList: [],
  },
  mutations: {
    setMuted(state, value) {
      state.muted = value
    },
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setPendingLoad(state, value) {
      state.pendingLoad = value
    },
    setParamsList(state, data) {
      state.paramsList = data
    },
    setResultParams(state, {key, value}) {
      Vue.set(state.resultParams, key, value)
    },
    setAllResultParams(state, value) {
      Vue.set(state, 'resultParams', value)
    }
  },
  actions: {
    setVacancyValues({commit}, vacancy) {
      if (!vacancy.params) return
      commit('setAllResultParams', JSON.parse(vacancy.params))
      commit('setMuted', false)
    }
  }
}

// { "3": { "values": [ { "key": 4 } ] }, "4": { "values": [ { "key": 5 } ], "isOpenComment": true, "comment": { "en": "dwdewdwdew", "lt": "", "pl": "", "ru": "", "ua": "" } } }
